import angular from 'angular';

import EditPageCtrl from '../../../newsfeed/EditPageCtrl';
import PageSubscribedCtrl from '../../../newsfeed/PageSubscribedCtrl';
import pageSubscribedUrl from '../../../newsfeed/page-subscribed.html';

import ManagePageListCtrl from './ManagePageListCtrl';
import listUrl from './list.html';
import editUrl from './edit.html';

const pagesModule = angular.module('sling.dashboard.manage.pages', []);

pagesModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.manage.pages', {
    url: '/pages',
    templateUrl: listUrl,
    controller: ManagePageListCtrl,
    controllerAs: 'ctrl',
    data: {
      title: 'Pages',
    },
    resolve: {
      newsfeedCollection(personaCollection, NewsfeedCollection) {
        return NewsfeedCollection.loadData();
      },
    },
  });

  $stateProvider.state('dashboard.manage.pages.create', {
    url: '/create',
    views: {
      '@dashboard': {
        templateUrl: editUrl,
        controller: EditPageCtrl,
        controllerAs: 'ctrl',
      },
    },
    resolve: {
      page() {
        return {
          open: true,
          personas: [],
        };
      },
    },
  });

  $stateProvider.state('dashboard.manage.pages.edit', {
    url: '/{pageId:[0-9]+}/edit',
    views: {
      '@dashboard': {
        templateUrl: editUrl,
        controller: EditPageCtrl,
        controllerAs: 'ctrl',
      },
    },
    resolve: {
      newsfeedCollection(personaCollection, NewsfeedCollection) {
        return NewsfeedCollection.loadData();
      },
      page(newsfeedCollection, NewsfeedCollection, $transition$) {
        const result = NewsfeedCollection.allChannels.find(
          (c) => String(c.id) === $transition$.params().pageId
        );
        if (result) {
          return NewsfeedCollection.getChannelDetails(result);
        }
      },
      advanced() {
        return false;
      },
    },
  });

  $stateProvider.state('dashboard.manage.pages.subscribed', {
    url: '/{pageId:[0-9]+}/subscribed',
    views: {
      '@dashboard': {
        templateUrl: pageSubscribedUrl,
        controller: PageSubscribedCtrl,
        controllerAs: 'ctrl',
      },
    },
    resolve: {
      page(newsfeedCollection, NewsfeedCollection, $transition$) {
        const result = NewsfeedCollection.allChannels.find(
          (c) => String(c.id) === $transition$.params().pageId
        );
        if (result) {
          return NewsfeedCollection.getChannelDetails(result);
        }
      },
    },
  });
});

export default pagesModule.name;
